module.exports = __webpack_public_path__ + "img/icon48.bac92378.png";